import React from 'react';
import { Framework } from '@/pages/layouts';
import ArticleContainer, {
  ArticleDetailPageProps,
} from '@/containers/article-detail';
import { ArticleDetailPageType } from '@/containers/article-detail/constants';
import styles from './index.scss';

export interface ArticleProps {
  type?: ArticleDetailPageProps['type'];
}

const Article = ({ type = ArticleDetailPageType.Normal }: ArticleProps) => {
  return (
    <Framework className={styles.Article}>
      <ArticleContainer type={type} />
    </Framework>
  );
};

export default Article;
